import { FilterContextData } from 'contexts/FilterContext';
import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface GrowthMarginBridgesContextType {
    selectedBridgesKPI: string;
    setSelectedBridgesKPI: (kpi: string) => void;
    isPercentageUnitSelected: boolean;
    setIsPercentageUnitSelected: (isPercentageUnitSelected: boolean) => void;
    previousYearGMBData: number;
    setPreviousYearGMBData: (previousYearGMBData: number) => void;
}

const GrowthMarginBridgesContext = createContext<GrowthMarginBridgesContextType | undefined>(undefined);

export const useGrowthMarginBridgesContext = () => {
    const context = useContext(GrowthMarginBridgesContext);
    if (!context) {
        throw new Error('useGrowthMarginBridgesContext must be used within a GrowthMarginBridgesProvider');
    }
    return context;
};

interface GrowthMarginBridgesProviderProps {
    children: ReactNode;
}

export const GrowthMarginBridgesProvider: React.FC<GrowthMarginBridgesProviderProps> = ({ children }) => {
    const { idForRestOfComponent } = useContext(FilterContextData);
    const [selectedBridgesKPI, setSelectedBridgesKPI] = useState<string>('');
    const [isPercentageUnitSelected, setIsPercentageUnitSelected] = useState<boolean>(false);
    const [previousYearGMBData, setPreviousYearGMBData] = useState<number>(0);

    useEffect(() => {
        setSelectedBridgesKPI('');
    }, [idForRestOfComponent]);

    return (
        <GrowthMarginBridgesContext.Provider
            value={{
                selectedBridgesKPI,
                setSelectedBridgesKPI,
                isPercentageUnitSelected,
                setIsPercentageUnitSelected,
                previousYearGMBData,
                setPreviousYearGMBData,
            }}
        >
            {children}
        </GrowthMarginBridgesContext.Provider>
    );
};
